import React, { Fragment /*, useState*/ } from 'react'
import { Typography } from '@mui/material'
import { TicketInfo } from '../../../interfaces/PickingValidate/TicketInfo'
import { StatesRoutes } from '../../../interfaces/PickingValidate/StatesRoutes'
import { PickingFinishHeaderVas } from './PickingFinishHeaderVas'
import { PickingValidateHeader } from '../../../interfaces/Picking/Picking'
import { useSnackbar } from '../../../hooks/useSnackbar'
import { SnackBar } from '../../SnackBar/Snackbar'
import { PickingValidateFinishDetailVas } from './PickingValidateFinishDetailVas'
import CustomAlert from '../../_WMS/AlertMessage/AlertMessage'

interface PickingValidateFinishProps {
  ticketInfo: TicketInfo
  statesRoute: StatesRoutes
  pickingHeader: PickingValidateHeader | undefined
  onVasComplete: () => void
}

export const PickingValidateFinishVas: React.FC<PickingValidateFinishProps> = ({
  ticketInfo,
  statesRoute,
  pickingHeader,
  onVasComplete
}) => {
  const { isActive, isSuccess, message } = useSnackbar()

  return (
    <Fragment>
      <Typography variant='h4' component='h2' gutterBottom>
        {`VALIDACIÓN - `}
        <h4
          style={{
            display: 'contents',
            fontWeight: 'bold',
            color: pickingHeader?.orderCancellationRequest
              ? 'red'
              : statesRoute.colorValidationStatus
          }}
        >
          {pickingHeader?.orderCancellationRequest
            ? 'CANCELADA'
            : statesRoute.validationFinished
            ? ` TERMINADA`
            : ` NO INICIADA`}
        </h4>
      </Typography>

      <PickingFinishHeaderVas
        ticketInfo={ticketInfo}
        statesRoute={statesRoute}
        pickingHeader={pickingHeader}
      />
      <CustomAlert
        severity='warning'
        maxWidth={'100%'}
        message='Algunos productos requieren asociar VAS'
      />
      {statesRoute.validationFinished && (
        <PickingValidateFinishDetailVas
          pickingRouteId={pickingHeader?.pickingRouteId || 0}
          onDataEmpty={onVasComplete}
        />
      )}

      {/* SNACKBAR */}
      <SnackBar
        message={message}
        open={isActive}
        status={isSuccess ? 'success' : 'error'}
      />
    </Fragment>
  )
}
